import validator from "email-validator";

export const emailIsValid = email => {
  return validator.validate(email);
};
